export const LANGUAGE_TO_COUNTRY_MAP: Record<string, string> = {
  en: 'gb',
};

export function getCountryForLanguage(languageCode: string) {
  return LANGUAGE_TO_COUNTRY_MAP[languageCode] ?? languageCode;
}

export function getLocaleCountryNameForLanguage(languageCode: string) {
  return languageCode
    ? new Intl.DisplayNames([languageCode], {
        type: 'language',
      }).of(languageCode)
    : '';
}
